import { useEffect, useState, useRef } from 'react';
import { db, storage, auth } from './firebaseConfig';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, addDoc, getDocs, Timestamp, query, where } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

function SubirHistoria() {
  const [userId, setUserId] = useState(null);
  const [grabando, setGrabando] = useState(false);
  const [contador, setContador] = useState(10);
  const [bloqueado, setBloqueado] = useState(false);
  const [motivoBloqueo, setMotivoBloqueo] = useState('');
  const [minutosRestantes, setMinutosRestantes] = useState(0);
  const [videoBlob, setVideoBlob] = useState(null);
  const videoPreviewRef = useRef(null);
  const navigate = useNavigate();

  // 🔐 Escuchar cambios de sesión
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      if (user) setUserId(user.uid);
      else setUserId(null);
    });

    return () => unsubscribe();
  }, []);

  // 🔍 Verificar bloqueo
  useEffect(() => {
    const verificarBloqueo = async () => {
      if (!userId) return;

      const publicacionesSnap = await getDocs(collection(db, 'services'));
      const publicacionActiva = publicacionesSnap.docs.find(doc => {
        const data = doc.data();
        return data.userId === userId && data.visible === true;
      });

      if (!publicacionActiva) {
        setBloqueado(true);
        setMotivoBloqueo('publicacion');
        return;
      }

      const q = query(
        collection(db, 'services', userId, 'historias'),
        where('timestamp', '>', Timestamp.fromMillis(Date.now() - 2 * 60 * 60 * 1000))
      );

      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        const ultima = snapshot.docs[0].data();
        const tiempoRestante = ultima.timestamp.toMillis() + 2 * 60 * 60 * 1000 - Date.now();
        setBloqueado(true);
        setMotivoBloqueo('historia');
        setMinutosRestantes(Math.ceil(tiempoRestante / (60 * 1000)));
      }
    };

    verificarBloqueo();
  }, [userId]);

  const grabarVideo = async () => {
    if (grabando || bloqueado) return;

    setGrabando(true);
    setContador(10);

    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
      const mediaRecorder = new MediaRecorder(mediaStream);
      const chunks = [];

      mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) chunks.push(e.data);
      };

      mediaRecorder.onstop = () => {
        const videoBlobFinal = new Blob(chunks, { type: 'video/webm' });
        setVideoBlob(videoBlobFinal);
        const videoURL = URL.createObjectURL(videoBlobFinal);
        if (videoPreviewRef.current) {
          videoPreviewRef.current.src = videoURL;
        }
        mediaStream.getTracks().forEach(track => track.stop());
      };

      mediaRecorder.start();

      let segundos = 10;
      const interval = setInterval(() => {
        segundos--;
        setContador(segundos);
        if (segundos === 0) clearInterval(interval);
      }, 1000);

      setTimeout(() => {
        mediaRecorder.stop();
        setGrabando(false);
      }, 10000);
    } catch (error) {
      console.error('Error accediendo a cámara/micrófono:', error);
      setGrabando(false);
    }
  };

  const subirHistoria = async () => {
    if (!videoBlob || !userId) return;

    try {
      const storageRef = ref(storage, `historias/${userId}_${Date.now()}.webm`);
      await uploadBytes(storageRef, videoBlob);
      const videoUrl = await getDownloadURL(storageRef);

      const ahora = Timestamp.now();
      const expiraEn = Timestamp.fromMillis(ahora.toMillis() + 60 * 60 * 1000);

      await addDoc(collection(db, 'services', userId, 'historias'), {
        videoUrl,
        timestamp: ahora,
        expiraEn,
      });

      navigate('/');
    } catch (error) {
      console.error('Error subiendo la historia:', error);
    }
  };

  if (!userId) {
    return (
      <div className="p-6 text-white">
        <p className="text-red-500">⚠️ Debes iniciar sesión para subir una historia.</p>
      </div>
    );
  }

  return (
    <div className="p-6 text-white">
      {bloqueado ? (
        motivoBloqueo === 'publicacion' ? (
          <p className="text-red-500">
            ⚠️ Debes tener una publicación activa para subir una historia.
          </p>
        ) : (
          <p className="text-red-500">
            ⚠️ Ya subiste una historia. Puedes subir otra en {minutosRestantes} minutos.
          </p>
        )
      ) : (
        <>
          <div className="mb-4">
            {videoBlob ? (
              <video ref={videoPreviewRef} controls className="w-64 h-64 rounded-lg" />
            ) : (
              <video ref={videoPreviewRef} autoPlay muted className="w-64 h-64 rounded-lg" />
            )}
          </div>

          {grabando && (
            <p className="text-lg font-bold text-yellow-400">⏱️ {contador}s</p>
          )}

          <button
            onClick={grabarVideo}
            disabled={grabando}
            className="bg-yellow-500 text-black px-4 py-2 rounded mb-2 disabled:opacity-50"
          >
            🎥 {grabando ? 'Grabando...' : 'Grabar video (10s)'}
          </button>

          <br />

          <button
            onClick={subirHistoria}
            disabled={!videoBlob}
            className="bg-green-600 text-white px-4 py-2 rounded disabled:opacity-50"
          >
            📤 Subir historia
          </button>
        </>
      )}
    </div>
  );
}

export default SubirHistoria;






